import React, { useEffect, useState } from "react";
import ServiceSelect from "../../ServiceSelect/ServiceSelect";
import { useBusinessContext } from "../../../../../context/business";
import { useParams } from "react-router-dom";
import AnimatedSearchBar from "../../OtherComponents/AnimatedSearchBar";

export default function ServiceForm({
  currentStepIndex,
  submitForm,
  useViewDetails,
}) {
  const {
    businessData: { services, businessData },
    selectedBusiness,
  } = useBusinessContext();
  const [selectedCategory, setSelectedCategory] = useState();
  const { categoryID } = useParams();
  const [searchValue, setSearchValue] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);

  useEffect(() => {
    if (categoryID?.startsWith("cat_")) {
      const idFromParam = categoryID.split("_")[1]; // "23"
       
      setSelectedCategory(parseInt(idFromParam));
    } else {
      setSelectedCategory(null); // fallback to "All"
    }
  }, [categoryID]);

  return (
    <div className="services-form-container">
      {currentStepIndex === 2 && (
        <div className="search-container">
          <AnimatedSearchBar
            categories={businessData?.categories}
            searchValue={searchValue}
            setFilteredResults={setFilteredResults}
            filteredResults={filteredResults}
            setSearchValue={setSearchValue}
            services={
              selectedCategory
                ? services.filter((s) =>
                    s.categories.includes(selectedCategory)
                  )
                : services
            }
          />
        </div>
      )}
      <form
        onSubmit={submitForm}
        className="step_container"
        data-is-active={(currentStepIndex === 2).toString()}
      >
        <div className="cat_btn_group">
          {businessData?.categories?.length !== 0 ? (
            <button
              type="button"
              className={`btn ${!selectedCategory ? "active" : ""}`}
              onClick={() => setSelectedCategory(null)}
            >
              {" "}
              All
            </button>
          ) : (
            ""
          )}

          {businessData?.categories?.map((item) => {
            if (item.services.length === 0) return null;

            return (
              <button
                type="button"
                key={item.id}
                className={`btn ${
                  selectedCategory === item.id ? "active" : ""
                }`}
                onClick={() => setSelectedCategory(item.id)}
              >
                {item.name}
              </button>
            );
          })}
        </div>
        {searchValue !== "" && (
          <div className="search-term-and-clear-holder">
            <p className="animated-search-term">Showing results for "<span className="search-term-bold">{searchValue}</span>"</p>
            <span
              type="button"
              className="clear-term-button"
              onClick={() => setSearchValue("")}
            >
              Clear
            </span>
          </div>
        )}

        {services?.map((service) => {
          const isVisible =
            (!selectedCategory ||
              service.categories.includes(selectedCategory)) &&
            (searchValue.trim() === "" ||
              service.name.toLowerCase().includes(searchValue.toLowerCase()));

          return (
            <div
              key={service.id}
              style={{ display: isVisible ? "block" : "none" }}
            >
              <ServiceSelect data={service} />
            </div>
          );
        })}

        {selectedBusiness?.totalCost?.total_services_cost > 0 ? (
          <div className="footer_rapper">
            <div className="app_max_width flex">
              <div className="details"></div>
              <button type="submit" className="round_button">
                Choose date & time
              </button>
            </div>
          </div>
        ) : null}
      </form>
    </div>
  );
}
